import { render, staticRenderFns } from "./StartupPressCard.vue?vue&type=template&id=3a7b9e09&scoped=true&"
import script from "./StartupPressCard.vue?vue&type=script&lang=js&"
export * from "./StartupPressCard.vue?vue&type=script&lang=js&"
import style0 from "./StartupPressCard.vue?vue&type=style&index=0&id=3a7b9e09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b9e09",
  null
  
)

export default component.exports